var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "agents@1x-a",
          d:
            "M18.4,8.944 L18.4,4.8 C18.4,4.3581722 18.0418278,4 17.6,4 C17.1581722,4 16.8,4.3581722 16.8,4.8 L16.8,8.944 C15.8508372,9.28850008 15.2188187,10.1902524 15.2188187,11.2 C15.2188187,12.2097476 15.8508372,13.1114999 16.8,13.456 L16.8,19.2 C16.8,19.6418278 17.1581722,20 17.6,20 C18.0418278,20 18.4,19.6418278 18.4,19.2 L18.4,13.456 C19.3491628,13.1114999 19.9811813,12.2097476 19.9811813,11.2 C19.9811813,10.1902524 19.3491628,9.28850008 18.4,8.944 Z M17.6,12 C17.1581722,12 16.8,11.6418278 16.8,11.2 C16.8,10.7581722 17.1581722,10.4 17.6,10.4 C18.0418278,10.4 18.4,10.7581722 18.4,11.2 C18.4,11.6418278 18.0418278,12 17.6,12 Z M12.8,13.744 L12.8,4.8 C12.8,4.3581722 12.4418278,4 12,4 C11.5581722,4 11.2,4.3581722 11.2,4.8 L11.2,13.744 C10.2508372,14.0885001 9.61881866,14.9902524 9.61881866,16 C9.61881866,17.0097476 10.2508372,17.9114999 11.2,18.256 L11.2,19.2 C11.2,19.6418278 11.5581722,20 12,20 C12.4418278,20 12.8,19.6418278 12.8,19.2 L12.8,18.256 C13.7491628,17.9114999 14.3811813,17.0097476 14.3811813,16 C14.3811813,14.9902524 13.7491628,14.0885001 12.8,13.744 L12.8,13.744 Z M12,16.8 C11.5581722,16.8 11.2,16.4418278 11.2,16 C11.2,15.5581722 11.5581722,15.2 12,15.2 C12.4418278,15.2 12.8,15.5581722 12.8,16 C12.8,16.4418278 12.4418278,16.8 12,16.8 Z M7.2,7.344 L7.2,4.8 C7.2,4.3581722 6.8418278,4 6.4,4 C5.9581722,4 5.6,4.3581722 5.6,4.8 L5.6,7.344 C4.65083725,7.68850008 4.01881866,8.59025239 4.01881866,9.6 C4.01881866,10.6097476 4.65083725,11.5114999 5.6,11.856 L5.6,19.2 C5.6,19.6418278 5.9581722,20 6.4,20 C6.8418278,20 7.2,19.6418278 7.2,19.2 L7.2,11.856 C8.14916275,11.5114999 8.78118134,10.6097476 8.78118134,9.6 C8.78118134,8.59025239 8.14916275,7.68850008 7.2,7.344 L7.2,7.344 Z M6.4,10.4 C5.9581722,10.4 5.6,10.0418278 5.6,9.6 C5.6,9.1581722 5.9581722,8.8 6.4,8.8 C6.8418278,8.8 7.2,9.1581722 7.2,9.6 C7.2,10.0418278 6.8418278,10.4 6.4,10.4 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#agents@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }